module.exports = __webpack_public_path__ + "img/bg_tuiguang.672faef0.jpeg";